export const SignalRGroups = {
  Tasks: {
    Key: 'taskMessages',
    Group: 'JoinTaskRoom',
    NewMessage: 'Task.NewMessage',
  },
  Sites: {
    Key: 'siteTasks',
    Group: 'JoinSiteRoom',
    NewMessage: 'Site.TasksChanged',
  },
  Trailers: {
    Key: 'trailers',
    Group: 'JoinSiteGroup',
    GroupYO: 'JoinSiteRoom', // TODO: firefly-1-9758-ui clean up after merge flag expires
    NewMessage: 'Trailer.NewActivity',
  },
  Doors: {
    Key: 'doors',
    Group: 'JoinSiteRoom',
    NewMessage: 'Site.DoorsChanged',
  },
};
